import { ProjectPage } from "./project";
import { ProjectsPage } from "./projects";

export const Pages = {
    Projects: ProjectsPage,
    Project: ProjectPage
}